import { Resources } from "./resources.js";
import { Simulation } from "./simulation.js";
import { InteractiveCanvas } from "./interactive_canvas.js";
import { WebBrowserClient } from "./webBrowserClient.js";
import { AuthorInterface } from "./sceneAuthorInterface/authorInterface.js";
import { WebAudio } from "./audio/webAudio.js";
import { ExternalModules } from './modules/ExternalModules.js';
import { InternalModules } from './modules/internalModules.js';
import { SceneModules } from './modules/sceneModules.js';
import { InternalAuth } from "./auth/InternalAuth.js";
import { NoInternalAuth } from './auth/NoInternalAuth.js';

let versionNumber = "0.2.4";

const auth0 = require('auth0-js');
let hash;

export async function startClient(state, newWebApplication, newServer, hasExternalModules = true, hasAuth = true) {
	state.libraryVersionNumber = versionNumber;

	state.auth = hasAuth ? new InternalAuth(state) : new NoInternalAuth();
	await state.auth.initialize();

	state.resources = new Resources();
	await state.resources.Initialize();

	state.application = newWebApplication(state);
	state.application.initialize();

	console.log(`Hello ${state.application.name}!`);

	state.server = newServer(state);
	await state.server.initialize();

	state.browser = new WebBrowserClient(state.resources, state.application, state.server);
	state.browser.initialize();
	state.server.setBrowser(state.browser);

	state.account = await state.server.getCustomerAccount();
	state.account.initialize();
	state.server.setClientCustomerAccount(state.account);

	await state.server.initialize2();

	state.canvas = new InteractiveCanvas();
	state.canvas.initialize();

	state.audio = new WebAudio(state.resources, state.account);
	state.audio.initialize();
	state.canvas.addComponent(state.audio);

	state.simulation = new Simulation(state.resources, state.canvas, state.account, state.server, state.audio);
	await state.simulation.initialize();
	state.canvas.addComponent(state.simulation);

	if (hasExternalModules) {
		state.externalModules = new ExternalModules(state, state.resources, state.canvas, state.account, state.server, state.audio);
		state.application.initializeExternalModules(state);
		state.externalModules.initialize();
		state.internalModules = new InternalModules(state.externalModules);
		state.application.initializeInternalModules(state);
		state.internalModules.initialize();
	}
	state.sceneModules = new SceneModules();
	state.application.initializeSceneModules(state);
	state.sceneModules.initialize();

	state.author = new AuthorInterface(state.resources, state.canvas, state.account);

	state.author.components.push(state.browser);
	state.author.components.push(state.application);
	state.author.components.push(state.audio);
	state.author.components.push(state.account);
	state.author.components.push(state.simulation);
	state.author.components.push(state.server);

	if (hasExternalModules) {
		state.author.components.push(state.externalModules);
		state.author.components.push(state.internalModules);
		state.externalModules.authoringInterface = state.author;
		state.internalModules.authoringInterface = state.author;
	}


	state.author.components.push(state.sceneModules);
	state.sceneModules.authoringInterface = state.author;

	state.author.initialize();
	state.canvas.addComponent(state.author);

	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState == "hidden") {
			state.saveState();
		}
	});

	if(!hasAuth){
		await state.canvas.start();
		return;
	}

	if (window.location.ancestorOrigins.length == 0) {
		let webAuth = new auth0.WebAuth({
			domain: process.env.AUTH0_ISSUER_BASE_URL_ORIGIN,
			clientID: process.env.AUTH0_CLIENT_ID
		});

		let authUrl

		if (!localStorage.getItem("hash")) {
			authUrl = webAuth.client.buildAuthorizeUrl({
				clientID: process.env.AUTH0_CLIENT_ID,
				responseType: 'token id_token',
				redirectUri: process.env.REDIRECT_URI,
				state: `test`,
				nonce: 'test'
			})
		} else { hash = localStorage.getItem("hash") }

		let auth0Response;
		let userInfo;
		let accessToken;
		let clientToken;

		if (window.location.hash) {
			hash = window.location.hash;
			localStorage.setItem("hash", `${hash}`);
			if (hash.split('=')[0] == "#access_token") {
				localStorage.setItem("hash", `${hash}`);
				webAuth.parseHash({ hash: hash, state: `test`, nonce: `test` }, function (err, authResult) {
					if (err) { return console.log(err); }
					webAuth.client.userInfo(authResult.accessToken, function (err, user) {
						if (err) { return console.log(err); }
						console.log("Window Hash")
						auth0Response = user;
					});
				});
			}
			window.location.href = window.location.origin;
		} else if (hash) {
			if (hash.split('=')[0] == "#access_token") {
				await webAuth.parseHash({ hash: hash, state: `test`, nonce: `test` }, async function (err, authResult) {
					if (err) { console.log("Invalid Token"); return await state.canvas.start(); }
					else { await handleAuth(authResult?.accessToken); }

					async function handleAuth(accessToken) {
						let authReqCount = 0;
						const authInterval = setInterval(async function () {
							userInfo = await reqUser();
							authReqCount += 1;
							if (userInfo) {
								const returnObj = {
									userId: userInfo.user_id || '',
									screenname: userInfo.user_metadata?.screenname || '',
									siteSlug: "demo",
									signedIn: true,
									action: "user",
									gameReturnKey: "TEST_KEY",
									email: userInfo.email,
									emailVerified: userInfo.email_verified,
									firstName: userInfo.user_metadata?.first_name,
									lastName: userInfo.user_metadata?.last_name
								}
								window.clearInterval(authInterval);

								state.server.account = { ...state.server.account, ...returnObj }
								state.server.account.firstName = state.server.account.firstName
								state.server.account.json = { ...state.server.account.json, ...state.server.account }

								window.postMessage({ action: "auth", receiptToken: `${"auth"}-${"token"}`, userInfo }, window.location.origin);

								await state.canvas.start();
							} else if (authReqCount == 3) {
								console.log("Request Limit Reached");
								window.clearInterval(authInterval);
								await state.canvas.start();
								return;
							}
						}, 2000);

						async function reqUser() {
							try {
								await webAuth.client.userInfo(accessToken, async function (err, user) {
									if (err) { 
										console.log("Invalid Token"); 
										return await state.canvas.start();
									} else {
										console.log("Local Hash");
										return auth0Response = user;
									}
								})
							}
							catch (err) { console.log("Invalid Token"); window.clearInterval(authInterval); return await state.canvas.start(); }
							if (auth0Response) {
								const clientTokenResponse = await fetch(`https://${process.env.AUTH0_ISSUER_BASE_URL_ORIGIN}/oauth/token`, {
									method: 'POST',
									headers: { 'Content-Type': 'application/json' },
									body: JSON.stringify({
										grant_type: 'client_credentials',
										client_id: `${process.env.AUTH0_CLIENT_ID}`,
										client_secret: `${process.env.AUTH0_CLIENT_SECRET}`,
										audience: `https://${process.env.AUTH0_ISSUER_BASE_URL_ORIGIN}/api/v2/`
									}),
								})

								const clientTokenData = await clientTokenResponse.json();
								clientToken = clientTokenData.access_token;

								let userSearchOptions = {
									method: 'GET',
									headers: { authorization: `Bearer ${clientToken}` }
								}

								if (clientToken) {
									const userSearchResponse = await fetch(`https://${process.env.AUTH0_ISSUER_BASE_URL_ORIGIN}/api/v2/users?q=email:\"${auth0Response.email}\"&search_engine=v2`, userSearchOptions);
									const userResponse = await userSearchResponse.json();
									if (userResponse.length == 1) {
										if (userResponse[0].identities[0].connection == process.env.AUTH0_CONNECTION) { return userResponse[0] }
									} else if (userResponse.length > 1) {
										for (let i = 0; i < userResponse.length; i++) {
											if (userResponse[i].identities[0].connection == process.env.AUTH0_CONNECTION) { return userResponse[i] }
										}
									} else { return; }
								}
							} else { return; }
						}
					}
				});
			}
		} else if (window.location.ancestorOrigins.length != 0) { // GET USER DATA FROM PARENT
			window.addEventListener('message', async function (event) {
				const { data } = event;
				if (data.receiptToken.split("-")[0] == "user") {
					state.server.setClientCustomerAccount(data.user)
					state.account.name = state.server.account.firstName
					state.account.json = state.server.account
				}
			});

			window.parent.postMessage({
				action: "user",          // Action key.
				receiptToken: "{receipt-token}", // Receipt validation token.
			}, window.location.ancestorOrigins[0])
		} else {
			await state.canvas.start();
		}
	}
}

